export default "__VITE_ASSET__DZrZHlbE__"